import { useState } from "react";
import { authService, userService } from "../../../services";
const ChangePassword = ({email}) => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [otp, setOtp] = useState("");
  const [requesting, setRequesting] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [message, setMessage] = useState("");

  // Request OTP
  const requestOtp = async () => {
    try {
      setRequesting(true);
      
      const otp = await authService.generateOtp({ otpType: "password", email });
      if (otp) {
        setOtpSent(true);
        setRequesting(false);
        setMessage("OTP sent to your email.");
      } else {
        setMessage("Failed to send OTP.");
        setRequesting(false);
      }
    } catch {
      setRequesting(false);
      setMessage("Error sending OTP.");
    }
  };

  // Submit New Password
  const handlePasswordChange = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setMessage("Passwords do not match!");
      return;
    }

    try {
      const updatedPassword = await authService.resetPassword({
        otpCode: otp,
        newPassword: password,
        email,
      });

      if (updatedPassword) {
        setOtpSent(false)
        setMessage("Password successfully changed!");
        setPassword("");
        setConfirmPassword("");
        setOtp("");
      } else {
        setMessage("Invalid OTP or error updating password.");
      }
    } catch {
      setMessage("Error updating password.");
    }
  };

  return (
    <div className="mb-6">
      <h3 className="text-lg font-medium">Change Password</h3>

      {!otpSent ? (
        <button
          onClick={requestOtp}
          className="bg-gray-800 text-white py-2 px-4 rounded hover:bg-gray-900"
          disabled={requesting}>
          {requesting ? "Requesting..." : "Request OTP"}
        </button>
      ) : (
        <form onSubmit={handlePasswordChange} className="space-y-3">
          <input
            type="text"
            placeholder="Enter OTP"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            className="w-full p-2 border rounded"
            required
          />
          <input
            type="password"
            placeholder="New Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full p-2 border rounded"
            required
          />
          <input
            type="password"
            placeholder="Confirm Password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            className="w-full p-2 border rounded"
            required
          />
          <button
            type="submit"
            className="bg-gray-800 text-white py-2 px-4 rounded hover:bg-gray-900">
            Update Password
          </button>
        </form>
      )}

      {message && <p className="text-sm text-red-500 mt-2">{message}</p>}
    </div>
  );
};

export default ChangePassword;
